import { PropsWithChildren } from "react";

type ColorBoxProps = {
  color: number;
  className?: string;
  tabIndex?: number;
};

export default function ColorBox(props: PropsWithChildren<ColorBoxProps>) {
  const backgroundColor = Array.from(
    Array(3),
    (_, i) => (props.color >> (8 * (2 - i))) & 0xff
  );
  const weight = [0.299, 0.587, 0.114];
  const level = backgroundColor.reduce(
    (sum, channel, index) => sum + weight[index] * channel,
    0
  );
  const color = level < 128 ? [255, 255, 255] : [0, 0, 0];

  return (
    <span
      tabIndex={props.tabIndex}
      className={props.className}
      style={{
        backgroundColor: `rgb(${backgroundColor.join()})`,
        color: `rgb(${color.join()})`,
      }}
    >
      {props.children}
    </span>
  );
}
